// Refetch helper for realtime subscriptions.
//
// Realtime events arrive in bursts (a webhook upsert touches many rows) and each used to
// trigger its own refetch. Those refetches could resolve out of order, so an older
// snapshot could overwrite a newer one. This coalesces bursts with a short debounce and
// tags every request with a sequence number so only the most recent response is applied.
// `query` resolves to a Supabase `{ data, error }` result; a thrown error is passed on
// in that same shape.
export const createLatestFetcher = (query, onResult, { debounceMs = 250 } = {}) => {
  let seq = 0;
  let timer = null;
  let closed = false;

  const run = async () => {
    const id = ++seq;
    let result;
    try {
      result = await query();
    } catch (error) {
      result = { data: null, error };
    }
    // Drop the result if a newer request has started or the subscription was closed.
    if (closed || id !== seq) return;
    onResult(result);
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(run, debounceMs);
  };

  const close = () => {
    closed = true;
    clearTimeout(timer);
  };

  return { run, schedule, close };
};
